"use client";

import { useContext, useEffect, useState } from "react";
import { usercontext } from "@/lib/context";
import { checkCustomerEnrollment } from "@/lib/registrationHelpers";

export function useEventEnrollmentCheck(eventId, isUniqueRegistration) {
  const { user } = useContext(usercontext);
  const [enrolled, setEnrolled] = useState(false);
  const [checking, setChecking] = useState(false);
  const [order_id, setOrderId] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const runCheck = async () => {
      if (!isUniqueRegistration || !eventId || !user?.id) {
        if (!cancelled) {
          setEnrolled(false);
          setChecking(false);
          setOrderId(null);
        }
        return;
      }

      setChecking(true);
      const result = await checkCustomerEnrollment(eventId);
      if (!cancelled) {
        setEnrolled(result.enrolled);
        setOrderId(result.order_id || null);
        setChecking(false);
      }
    };

    runCheck();

    return () => {
      cancelled = true;
    };
  }, [eventId, isUniqueRegistration, user?.id]);

  return { enrolled, checking, order_id };
}
